import HiggsPromise from '../../utils/higgsPromise';

// 财务画像-概述-获取造假信息
export function queryOverviewFraud(data) {
    return HiggsPromise({
        url: '/finance/portrait/fraud',
        data: data
    });
}

// 财务舞弊动机与表象
export function queryFraudAppearance(data) {
    return HiggsPromise({
        url: '/finance/portrait/fraud/appearance',
        data: data
    });
}

// 财务画像-概述-获取风险信息
export function queryOverviewRisk(data) {
    return HiggsPromise({
        url: '/finance/portrait/risk',
        data: data
    });
}

// 财务画像-概述-财务隐患提示
export function queryRiskDanger(data) {
    return HiggsPromise({
        url: '/finance/portrait/risk/appearance',
        data: data
    });
}



// WEBPACK FOOTER //
// ./src/services/financialPicture/overview.js